import {Tr} from "@/i18n/i18n";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import TextUtils from "@/utils/text-utils";
import {Player, UserSource} from "@/store/player/types";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import Text = Phaser.GameObjects.Text;
import {BankOption} from "@/store/shop/types";
import {GameState} from "@/constants/game-state";
import {IntegrationUtils} from "@/utils/integration-utils";

export class AbstractShopBankPanel extends Phaser.GameObjects.Container {

    public static HEIGHT = 144;

    protected buyButton!: SquareButton;
    protected buyPriceText!: Text;
    protected valuteText!: Text;

    constructor(scene: Phaser.Scene, x: number, y: number, bo: BankOption, player: Player, userSource: UserSource, callback: () => void, isReward: boolean = false, productPriceView: string | undefined = undefined) {
        super(scene);

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.width = CU.CANVAS_WIDTH;
        this.height = this.getHeight(bo.decorationId);

        const back = SpriteUtils.addImage(this.scene, 0, 0, this.getBackAtlas(bo.decorationId), this.getBackKey(bo.decorationId)).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.getHeight(bo.decorationId) * CU.S);
        this.add(back);

        let keyAtlas = isReward ? Keys.UI_ARROW_RIGHT : Keys.UI_GOLDEN_CHECK;
        this.buyButton = SpriteUtils.scale(new SquareButton(this.scene, 530, this.getBuyButtonPos(bo.decorationId), -10, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, keyAtlas, this.getBuyButtonText(bo), false, 84 * CU.S, 84 * CU.S, 0), 0.7 / CU.S);

        this.setBuyCallback(this.buyButton, callback);

        let price = productPriceView === undefined ? (bo.price % 1000 === 0 ? TextUtils.formatGems(bo.price) : String(bo.price)) :  productPriceView;
        let pricePositionX = 508 + AbstractShopBankPanel.getButtonTextShift(userSource) + (productPriceView === undefined ? 0 : 15)
        let yaPrice = undefined;
        let gpPrice = undefined;
        if (userSource === UserSource.ya) {
            if (GameState.YANDEX_PRODUCTS.has(bo.id)) {
                yaPrice = GameState.YANDEX_PRODUCTS.get(bo.id);
                if (!!yaPrice) {
                    price = yaPrice;
                    pricePositionX += 14;
                }
            }
        } else if (IntegrationUtils.isGPUserSource(userSource)) {
            if (GameState.GP_PRODUCTS.has(bo.id)) {
                gpPrice = GameState.GP_PRODUCTS.get(bo.id);
                if (!!gpPrice) {
                    price = gpPrice;
                    pricePositionX += 14;
                }
            } else {
                return; // No price available for this product
            }
        }

        this.buyPriceText = TextUtils.addText(scene,
            price, pricePositionX, this.getBuyButtonPos(bo.decorationId) + 32, this.getTextColor(), 13, 'bold', 200);

        this.buyButton.setVisible(this.buyButtonVisible(bo));
        this.buyPriceText.setVisible(this.priceVisible(bo));

        const separator = SpriteUtils.addSprite(this.scene!, 0, this.getHeight(bo.decorationId) + 3, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0, 1);

        this.add([this.buyButton, this.buyPriceText, separator]);

        if (this.priceVisible(bo)) {
            switch (userSource) {
                case UserSource.own:
                case UserSource.mystore:
                case UserSource.exe:
                case UserSource.beeline:
                case UserSource.crazygames:
                    if (productPriceView === undefined) {
                        this.valuteText = TextUtils.addText(scene, bo.valuteName, this.buyPriceText.getBounds().right / CU.S + 5, this.buyPriceText.y / CU.S,
                            this.getTextColor(), 13, 'bold', 200).setOrigin(0, 0.5);
                    }
                    break;
                case UserSource.ok:
                    this.valuteText = TextUtils.addText(scene, Tr('OK'), this.buyPriceText.getBounds().right / CU.S + 5, this.buyPriceText.y / CU.S,
                        this.getTextColor(), 13, 'bold', 200).setOrigin(0, 0.5);
                    break;
                case UserSource.vk:
                    this.valuteText = TextUtils.addText(scene, Tr('gls'), this.buyPriceText.getBounds().right / CU.S + 5, this.buyPriceText.y / CU.S,
                        this.getTextColor(), 13, 'bold', 200).setOrigin(0, 0.5);
                    break;
                case UserSource.ya:
                    this.valuteText = TextUtils.addText(scene, !!yaPrice ? '' : Tr('yan'), this.buyPriceText.getBounds().right / CU.S + 5, this.buyPriceText.y / CU.S,
                        this.getTextColor(), 13, 'bold', 200).setOrigin(0, 0.5);
                    break;
                case UserSource.gp:
                case UserSource.gp_partner:
                case UserSource.gp_playdeck:
                    this.valuteText = TextUtils.addText(scene, !!gpPrice ? '' : 'GP', this.buyPriceText.getBounds().right / CU.S + 5, this.buyPriceText.y / CU.S,
                        this.getTextColor(), 13, 'bold', 200).setOrigin(0, 0.5);
                    break;
                case UserSource.tg:
                    this.valuteText = TextUtils.addText(scene, Tr('tg.star'), this.buyPriceText.getBounds().right / CU.S + 5, this.buyPriceText.y / CU.S,
                        this.getTextColor(), 13, 'bold', 200).setOrigin(0, 0.5);
                    break;
                case UserSource.foto:
                    this.valuteText = TextUtils.addText(scene, Tr('fm'), this.buyPriceText.getBounds().right / CU.S + 5, this.buyPriceText.y / CU.S,
                        this.getTextColor(), 13, 'bold', 200).setOrigin(0, 0.5);
                    break;
                case UserSource.kong:
                    this.valuteText = TextUtils.addText(scene, 'KR', this.buyPriceText.getBounds().right / CU.S + 5, this.buyPriceText.y / CU.S,
                        this.getTextColor(), 13, 'bold', 200).setOrigin(0, 0.5);
                    break;
            }
            if (!!this.valuteText) {
                this.add(this.valuteText);
            }
        }
    }

    protected setBuyCallback(buyButton: SquareButton, callback: () => unknown): void {
        buyButton.setCallback(() => {
            callback();
        });
    }

    protected getTextColor(): string {
        return '#ffffff';
    }

    private static getButtonTextShift(userSource: UserSource): number {
        switch (userSource) {
            case UserSource.own:
            case UserSource.exe:
                return 0;
            case UserSource.mail:
                return 12;
            case UserSource.ok:
            case UserSource.kong:
                return 7;
            case UserSource.vk:
                return 3;
            case UserSource.ya:
            case UserSource.foto:
            case UserSource.gp:
            case UserSource.gp_partner:
            case UserSource.gp_playdeck:
                return 7;
        }
        return 0;
    }

    protected getBuyButtonPos(decorationId: string) {
        return this.getHeight(decorationId) / 2 - 4;
    }

    protected getBuyButtonText(bo: BankOption) {
        if (bo.price > 0) {
            return Tr('kupit');
        }
        return Tr('get');
    }

    protected buyButtonVisible(bo: BankOption): boolean {
        return true;
    }

    protected priceVisible(bo: BankOption): boolean {
        return true;
    }

    protected getBackAtlas(decorationId: string) {
        return Keys.ATLAS_SHOP_UI;
    }

    protected getBackKey(decorationId: string): string | undefined {
        return Keys.UI_SHOP_PANEL_BACK;
    }

    protected getHeight(decorationId: string) {
        return AbstractShopBankPanel.HEIGHT;
    }

}
